import { render, staticRenderFns } from "./OfflineIndicator.vue?vue&type=template&id=57a63896&scoped=true"
import script from "./OfflineIndicator.vue?vue&type=script&lang=js"
export * from "./OfflineIndicator.vue?vue&type=script&lang=js"
import style0 from "./OfflineIndicator.vue?vue&type=style&index=0&id=57a63896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a63896",
  null
  
)

export default component.exports